import { monserratSemiBold } from '@habitech/shared';
import { useDocumentsHistoryByNid } from '@domains/documents-review/hooks/useDocumentsHistoryByNid';
import {
  HistoryCardCO,
  HistoryCardMX,
} from '@domains/documents-review/components/DocumentsHistoryList/components';
import { CountryCode } from '@domains/country';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { useSelector } from 'react-redux';
import {
  DocumentHistoryItemCO,
  DocumentHistoryItemMX,
} from '@domains/documents-review/interfaces/interfaces';

interface DocumentsHistorySectionProps {
  nid?: string;
}

export const DocumentsHistorySection = ({
  nid,
}: DocumentsHistorySectionProps) => {
  const country = useSelector(getCountry) as CountryCode;
  const { data: history = [], isLoading: isLoadingHistory } =
    useDocumentsHistoryByNid({ nid });

  if (isLoadingHistory) {
    return null;
  }

  if (history.length === 0) {
    return null;
  }

  return (
    <div className="d-flex flex-column">
      <div
        className="fw-bold px-4 pb-2 fs-6"
        style={{ fontFamily: monserratSemiBold }}
      >
        Historial de Revisiones
      </div>
      <div className="d-flex flex-column gap-2">
        {history.map((item: any, index: number) => {
          if (country === CountryCode.MX) {
            return (
              <HistoryCardMX
                key={item.id}
                item={item as DocumentHistoryItemMX}
                index={index}
              />
            );
          }
          return (
            <HistoryCardCO
              key={item.id}
              item={item as DocumentHistoryItemCO}
              index={index}
            />
          );
        })}
      </div>
    </div>
  );
};



